import { graphql, type HeadFC } from 'gatsby';
import React from 'react';

import type { PageContext } from 'src/components/common/page-context';
import { PageHead } from 'src/components/common/page-head';
import { GenericFormContent } from 'src/components/enquiry/generic-form-content';
import type Seo from 'src/models/global/seo-content';

type GlobalGenericFormProps = {
  data: GlobalGenericFormPageData;
};

type GlobalGenericFormPageData = {
  json: {
    name: string;
    globalGenericFormPageContent: Queries.GenericFormPageContent;
    seo: Seo;
  };
};

export const query = graphql`
  query GlobalGenericFormPage($id: String, $globalDirectoryName: String!, $language: String!) {
    json: globalGenericFormPageJson(id: { eq: $id }) {
      name
      seo {
        pageTitle
        pageDescription
      }
      globalGenericFormPageContent {
        formUiElements {
          ..._FormUiElements
        }
        formSettings {
          ..._FormSettings
        }
        content {
          ..._GenericPageContentUnion
        }
      }
    }
    ..._GlobalCmsRecord
  }
`;

const GlobalGenericFormPage: React.FC<GlobalGenericFormProps> = ({ data }) => {
  const { globalGenericFormPageContent, name } = data.json;

  return <GenericFormContent content={globalGenericFormPageContent} name={name} />;
};

export default GlobalGenericFormPage;

export const Head: HeadFC<GlobalGenericFormPageData, { id: string; baseContext: PageContext }> = ({
  data,
  pageContext,
}) => (
  <PageHead
    pageContext={pageContext.baseContext}
    seo={{
      titleOverride: data.json.seo.pageTitle,
      descriptionOverride: data.json.seo.pageDescription,
    }}
  />
);
